import { useMemo, useState } from 'react'

import { getBookingInsuranceStatus } from '@flecto/api/saas'
import { useQueryGetAllBookingInsurances } from '@flecto/core/saas'
import { type ParameterID } from '@flecto/types'
import { useDebouncedCallback } from '@flecto/utils'

type InsuranceStatusProps = {
  bookingId?: ParameterID
}

export const useInsuranceStatus = ({ bookingId }: InsuranceStatusProps) => {
  const [isLoading, setLoading] = useState(false)

  const { data: queryList, refetch: refetchQueryList } =
    useQueryGetAllBookingInsurances({ bookingId })

  const _handleGetStatus = () => {
    if (Number.isSafeInteger(Number(bookingId))) {
      getBookingInsuranceStatus(bookingId ?? '', {
        wait: 1,
        onmessage: (event) => {
          const status = JSON.parse(event.data).status

          if (status === 'pending' && !isLoading) {
            setLoading(true)
          } else {
            refetchQueryList()
            setLoading(false)
          }
        },
      })
    }
  }

  const [getHandleGetStatus] = useDebouncedCallback(_handleGetStatus, 1000)

  const data = useMemo(() => {
    const insuranceUntil = queryList?.until
    const claimUntil = insuranceUntil ? new Date(insuranceUntil) : new Date()

    if (claimUntil && new Date() > claimUntil) {
      return 'within_claim_period'
    }

    return queryList?.meta_status ?? null
  }, [queryList])

  return {
    mutate: getHandleGetStatus,
    data,
    isLoading,
  }
}
